import PropTypes from 'prop-types';
import './style.scss';

const MapLegendTitle = ({unit, children}) => {
	return (
		<div className="worldWater-MapLegendTitle">
			<div className="worldWater-MapLegendTitle-name">{children}</div>
			{unit ? (
				<span className="worldWater-MapLegendTitle-unit">[{unit}]</span>
			) : null}
		</div>
	);
};

MapLegendTitle.propTypes = {
	children: PropTypes.node,
	unit: PropTypes.string,
};

export default MapLegendTitle;
